import React from "react";
import about from "./assets/about.webp";
import { Link } from "react-router-dom";
import { FaRegStar } from "react-icons/fa";
import { AiOutlineAim } from "react-icons/ai";
import { SlSymbolMale } from "react-icons/sl";
import { MdOutlineAutoGraph } from "react-icons/md";
import { LuFlag } from "react-icons/lu";
import { GiAnthem } from "react-icons/gi";
import GoToTop from "../GoToTop";

function About() {
  return (
    <>
      <GoToTop />
      <section id="about" className="about section">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row g-4 align-items-stretch">
            <div
              className="col-xl-5 order-lg-2"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <aside className="showcase">
                <figure className="showcase-main">
                  <img src={about} alt="Our Journey" className="img-fluid" />
                  <figcaption
                    className="badge-note"
                    data-aos="zoom-in"
                    data-aos-delay="350"
                  >
                    {/* <i
                      className="bi bi-graph-up-arrow"
                      style={{ padding: "5px 10px" }}
                    >
                      <MdOutlineAutoGraph />
                    </i>
                    <div>
                      <strong>Established</strong>
                      <small>
                        The Karbi Lammet Amei came into existence on 27th March,
                        1966 at the residence of Sar Dhaniram Rongpi, the then
                        C.E.M of Karbi Anglong Autonomous Council.
                      </small>
                    </div> */}
                  </figcaption>
                </figure>
              </aside>
            </div>

            <div
              className="col-xl-7 order-lg-1"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <article className="intro-card">
                <div className="intro-head">
                  <span className="kicker">
                    <FaRegStar />
                    Our Story
                  </span>
                  <h2>Introduction to Karbi Tribe</h2>
                </div>

                <div className="intro-body" style={{ textAlign: "justify" }}>
                  <p>
                    The Karbis constitute an important ethnic group in the hill
                    areas of Assam. They are one of the most numerous and
                    homogenous of the many Tibeto-Burman communities inhabiting
                    Assam. Racially the Karbis belong to the Mongoloid group and
                    linguistically Kuki-Chin sub-group of languages. Although at
                    present, they are found to inhabit in the Karbi Anglong
                    districts, nevertheless, some Karbi inhabited pockets are
                    found in the N.C. Hills, Kamrup, Morigaon, Nogaon and
                    Sonitpur districts of Assam.
                  </p>
                  <p className="mb-0">
                    By the advancement and spread of modern education, there
                    came a certain change in the minds of the Karbis. They began
                    to feel uncomfortable to find that nothing about their tribe
                    has been documented and very less number also negligible
                    number of tribe were aware of the importance of writing and
                    conscious about the degrading and vanishing situation that
                    Karbi language was heading towards day after day. The very
                    little number of literate population also added fuel to the
                    problem. However, the little number of literate people made
                    up their mind to change the scenario and thus began writing.
                    Mention can be made of writers like Bonglong Terang and
                    Semson Sing Ingti. They were the ones to lead the way for
                    Karbis in the journey of writing their stories in their own
                    language with their own hands.
                  </p>
                </div>
              </article>
            </div>
          </div>

          <div className="mt-4">
            <article className="intro-card">
              <div className="intro-body" style={{ textAlign: "justify" }}>
                <p>
                  In the year 1952, the Karbis were given District Council by
                  the Government for the protection of their ethnic culture and
                  for the quick development of the tribe and district as a
                  whole. Since then, Karbi Anglong saw several developments;
                  especially there was increase in the number of educated
                  population. College graduates began to organize themselves to
                  work for the cause of the development of the tribe. Several
                  organizations came up to unite people to stand for the rights
                  of the people, prominent among them being the Karbi Students’
                  Association [KSA] led by Pratap Ch. Tokbi and Gandhiram
                  Timung. It was during their period that some Karbis like Prof.
                  Rongbong Terang, Longkam Teron, Kehai Bey and others felt the
                  need of an organization that will work for the development of
                  Karbi language. They have by then already seen the work of
                  Asom Xahitya Xabha and its contributions to the Assamese
                  literature and community as a whole.
                </p>
                <p className="mb-0">
                  The fact that although they are speaking in Karbi but are
                  having nothing to read in their mother tongue troubled them a
                  lot. Also worries about the dark future of the language which
                  was slowly losing its existence in front of other greater and
                  established languages compelled them to write and work
                  together to preserve their language, which are an integral
                  part of their culture and an identity of the tribe.
                </p>

                {/* <div className="feature-list row gy-3">
                         <div
                           className="col-xxl-6"
                           data-aos="fade-up"
                           data-aos-delay="250"
                         >
                           <div className="feature-item">
                             <i>
                               <AiOutlineAim />
                             </i>
                             <div className="text">
                               <h6>AIM</h6>
                               <p>
                                 Preserving the literature, tradition, culture,
                                 myths, rituals, folklores, chants and songs. To
                                 research and rewrite the old-aged songs and stories
                                 and bring them in the global scene. To give ideas
                                 and moral support to those who are working for the
                                 welfare of the tribe.
                               </p>
                             </div>
                           </div>
                         </div>
                         <div
                           className="col-xxl-6"
                           data-aos="fade-up"
                           data-aos-delay="300"
                         >
                           <div className="feature-item">
                             <i className="bi bi-palette2">
                               <SlSymbolMale />
                             </i>
                             <div className="text">
                               <h6>SYMBOL</h6>
                               <p>
                                 There will be a circle with “Nepi alam ne chinghon
                                 chenam”, “Keseng 1966” written on its top in an arc
                                 form. In the centre of the circle will be a shining
                                 sun and a ‘Maino’ bird. Below the circle will be a
                                 ‘Pe Seleng’ with ‘Karbi Lammet Amei’ written on it.
                                 This symbol shall be adopted by all the branches of
                                 the organization.
                               </p>
                             </div>
                           </div>
                         </div>
                       </div> */}
              </div>
            </article>
          </div>

          <div className="mt-4">
            <article className="intro-card">
              <div className="intro-head">
                <h3>Origin of Karbi Lammet Amei</h3>
              </div>
              <div className="intro-body" style={{ textAlign: "justify" }}>
                <p>
                  The Karbi Lammet Amei was formed to develop, preserve and
                  popularize Karbi language and literature. It came into
                  existence on 27th March, 1966 at the residence of Sar Dhaniram
                  Rongpi, the then C.E.M of Karbi Anglong Autonomous Council.
                  The meeting to form the organization was called by one of the
                  most important figures of Karbi literature Longkam Teron. At
                  the end of the meeting, a unanimous decision was taken to name
                  the new body as Karbi Lammet Amei [K.L.A], an apex body of
                  Karbi Literary Organization. Longkam Teron was made its first
                  President and Rongbong Terang as the first General Secretary.
                  Mohan Sing Teron and Rolen Engti were made Vice President and
                  Asst. Secretary respectively. Joysing Terang, Kehai Bey,
                  Durmen Milik, Jonasing Terang and Bronson Engti were the
                  executive members of the first batch of the body. To guide and
                  supervise the organization Dhaniram Rongpi, C.E.M [KAAC],
                  Joysing Doloi, E.M and Sar Rongpi, E.M were made advisers. It
                  was right on the day of formation that the task to bring out a
                  book on Karbi grammar was given to Longkam Teron and Rongbong
                  Terang.
                </p>
                <p className="mb-0">
                  Karbi Lammet Amei organises Annual General Conference after
                  every two years. The first conference was held at Diphu on the
                  18th of March, 1973. Since then, the organisation have
                  travelled a long journey and celebrated their Golden Jubilee
                  year in 2016. The Golden Jubilee was held from 22nd-25th
                  September, 2016 at Joysing Doloi Terang Auditorium, Diphu.
                  Throughout this long fifty years, the organisation has
                  remained as the sole body working for Karbi literature and
                  language. The whole society looks towards it for the
                  protection, preservation and development of their language.
                </p>

                <div className="intro-head mt-5">
                  <h3>Constitution</h3>
                </div>

                <p>
                  The Constitution of Karbi Lammet Amei from its date of
                  formation was made flexible and therefore certain amendments
                  are done time to time by unanimous decision taken during
                  annual conferences. The first amendment was made on 9th March,
                  1986 and second amendment on 8th May, 1998.
                </p>
                <p>
                  The preface to the Constitution states that the Karbis are
                  also a unique tribe and that Karbi Anglong district of Assam
                  is their main homeland. To work for the development of the
                  Karbi language, on the 27th of March, 1966, the ‘Karbi Lammet
                  Amei’ came into existence. Some major points made in the
                  Constitution are as follows-
                </p>

                <div className="feature-list row gy-3">
                  <div
                    className="col-xxl-6"
                    data-aos="fade-up"
                    data-aos-delay="250"
                  >
                    <div className="feature-item">
                      <i>
                        <AiOutlineAim />
                      </i>
                      <div className="text">
                        <h6>AIM</h6>
                        <p>
                          Preserving the literature, tradition, culture, myths,
                          rituals, folklores, chants and songs. To research and
                          rewrite the old-aged songs and stories and bring them
                          in the global scene. To give ideas and moral support
                          to those who are working for the welfare of the tribe.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xxl-6"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <div className="feature-item">
                      <i className="bi bi-palette2">
                        <SlSymbolMale />
                      </i>
                      <div className="text">
                        <h6>SYMBOL</h6>
                        <p>
                          There will be a circle with “Nepi alam ne chinghon
                          chenam”, “Keseng 1966” written on its top in an arc
                          form. In the centre of the circle will be a shining
                          sun and a ‘Maino’ bird. Below the circle will be a ‘Pe
                          Seleng’ with ‘Karbi Lammet Amei’ written on it. This
                          symbol shall be adopted by all the branches of the
                          organization.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xxl-6"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <div className="feature-item">
                      <i className="bi bi-palette2">
                        <LuFlag />
                      </i>
                      <div className="text">
                        <h6>FLAG</h6>
                        <p>
                          K.L.A shall use silk cloth for its flag. The flag will
                          have the K.L.A symbol on it. On the President, Vice
                          President and General Secretary shall be eligible to
                          unfurl the flag. To pay condolence and tribute to the
                          departed soul of a member of K.L.A, the flag shall be
                          lowered [Half-mast].The dead body of a member of K.L.A
                          can be covered with the flag but should not be burned
                          in the funeral or buried. The size of the flag shall
                          be 3:2’.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-xxl-6"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <div className="feature-item">
                      <i className="bi bi-palette2">
                        <GiAnthem />
                      </i>
                      <div className="text">
                        <h6>ANTHEM</h6>
                        <p>
                          During the 1973 Conference held at Member Hostel,
                          Diphu on the 22nd of January it was agreed to make
                          “Nepi alam ne kachinghon chenam”, a song written by
                          Kehai Bey as the anthem of the organization. “Nepi
                          alam ne kachinghon chenam” literally means “I love my
                          mother tongue truly.”
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <div className="mt-4">
            <article className="intro-card">
              <div className="intro-head">
                <h3>The Central Committee and the Branch Committee</h3>
              </div>
              <div className="intro-body" style={{ textAlign: "justify" }}>
                <p>
                  The total number of members inthe Central (Atiri Amei),
                  Regional (Longri Amei)and the Branch Committee (Aro Amei)
                  shall be 45. Each committee will have a President, 2 Vice
                  Presidents, General Secretary, two Asst. Secretaries and other
                  port-folios along will 23 executive members. The Organizing
                  Secretary will be in-charge of formation of branch committees.
                </p>
              </div>

              <div className="intro-head mt-5">
                <h3>Tenure and power of the Central Committee</h3>
              </div>
              <div className="intro-body" style={{ textAlign: "justify" }}>
                <p>
                  The tenure is fixed as two years. They shall give directions
                  to the working committee. They can change and adopt new rules.
                  However, it shall be done after unanimous decisions of the
                  delegates present in the discussions. They can disagree to the
                  views and points of the executive body. The central committee
                  would decide whom to point in the place of anybody who takes
                  voluntary retirement or is expelled from the executive
                  committee or in case of his demise.
                </p>
              </div>

              <div className="intro-head mt-5">
                <h3>Membership</h3>
              </div>
              <div className="intro-body" style={{ textAlign: "justify" }}>
                <p>
                  There are two types of membership in Karbi Lammet Amei. One is
                  ‘Armu Bangphu’ or General Member who are directly involved in
                  the working of the organization. The other is ‘Kai arjon
                  Bangphu’ of ‘Life time Members’ who do not directly involve in
                  the works but are supporters and well-wishers of the
                  organization. An individual can take either of the two
                  memberships or go for both.
                </p>
              </div>
            </article>
          </div>

          <div className="mt-4">
            <article className="intro-card">
              <div className="intro-head">
                <h3>Lammet Arani or Literary Day</h3>
              </div>
              <div className="intro-body" style={{ textAlign: "justify" }}>
                <p>
                  The Karbi Lammet Amei formed on the 27th of March 1966. Every
                  year on this auspicious day, the organization shall observed
                  or celebrate the ‘Lammet Arani’ to mark the occasion.
                </p>
              </div>

              <div className="intro-head mt-5">
                <h3>Script</h3>
              </div>
              <div className="intro-body" style={{ textAlign: "justify" }}>
                <p>
                  The Constitution also states that the K.L.A adopts the Roman
                  Script for writing in Karbi. It shall not entertain the use of
                  other scripts for any form of writing in Karbi.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
